import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0.7rem;
  color: ${p => p.theme.primaryTextColor};
  background-color: ${p => p.theme.textColor};
  position: fixed;
  top: 3.8rem;
  left: 0;
  right: 0;
  z-index: 99;
  /* Sits directly below TopBar (fixed, same stacking) — needs the identical smart-banner
     shift, including smartbanner-scrolled-past, so the two stay aligned with each other at
     every scroll position; see TopBar.style.js for the full explanation. */
  html.smartbanner-show:has(.smartbanner-top):not(.smartbanner-scrolled-past)
    & {
    top: 11.8rem;
  }
`;

export const StatusMessage = styled.h1`
  font-size: 1.5rem;
  font-weight: normal;
  text-align: center;
  margin: 0.2rem;
  p {
    padding: 0;
    margin: 0;
  }
  a {
    text-decoration: underline;
    color: ${p => p.theme.primaryTextColor};
  }
  ${media.small`
    font-size: 1.4rem;
  `};
`;
